
export namespace WishlistDisplay {
let initWishlistDisplay = () => {
	let $favoritesLink = $('.js-favorites');
	$favoritesLink.append('<span class="js-favorites-count site-header__favorites-count">0</span>');
	
	updateWishlistCount();

	$(window).on('favorites', function() {
		updateWishlistCount();
	});
}

let updateWishlistCount = () => {
	let $favoritesDisplay = $('.js-favorites-count');

	if (localStorage.getItem('wishlist-products')) {
		let productIds = JSON.parse(localStorage.getItem('wishlist-products'));
		
		let favoriteCount = 0;
		if (Array.isArray(productIds)) {
			favoriteCount = productIds.length;
		}	
		$favoritesDisplay.text(`${favoriteCount}`);
	}
}

export function init() {
	initWishlistDisplay();
 }
}

